import { render, staticRenderFns } from "./EditCsrfWhitelistDialogBody.vue?vue&type=template&id=0e1f7df4&scoped=true&"
import script from "./EditCsrfWhitelistDialogBody.vue?vue&type=script&lang=ts&"
export * from "./EditCsrfWhitelistDialogBody.vue?vue&type=script&lang=ts&"
import style0 from "./EditCsrfWhitelistDialogBody.vue?vue&type=style&index=0&id=0e1f7df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1f7df4",
  null
  
)

export default component.exports